import PropTypes from 'prop-types';
import React, { memo, useCallback, useState } from 'react';
import { Map } from 'immutable';
import classNames from 'classnames';
import readXlsxFile from 'read-excel-file';

import { schema } from '../../../config/constants/search/xlsxUploadScema.js';

import { BrowseCheckbox } from '../BrowseCheckbox';

import style from './style.module.css';

const BrowseUploadSearchComponent = ({ filter, info, onChange, clearStatus }) => {
  const [fileName, setFileName] = useState('');
  const [fileChosen, setFileChosen] = useState(false);

  const UPLOAD_SEARCH_TOOLTIP =
    'Your Excel file may have 1-3 columns with the headers "Name", "Website", and/or "Phone"';

  const uploadTemplatePath = 'https://harvey.saritasa.rocks/reports/uploadTemplate.xlsx';

  const handleChange = useCallback(
    event => {
      const fileInput = event.target;

      if (!fileInput.files[0]) {
        setFileName('');
        setFileChosen(false);

        onChange({
          filterName: filter.get('name'),
          filterData: {
            data: [],
          },
        });
      } else {
        setFileName(fileInput.files[0].name);
        setFileChosen(true);

        readXlsxFile(fileInput.files[0], { schema }).then(data => {
          if (!data.rows.length) {
            setFileName('');
          }
          // The data will be appended search filter to send to server.

          onChange({
            filterName: filter.get('name'),
            filterData: {
              data: data.rows,
            },
          });
        });
      }
    },
    [onChange, filter],
  );

  const resetFile = event => {
    const fileInput = event.target;

    fileInput.value = null;
  };

  return (
    <BrowseCheckbox filter={filter} info={info} onChange={onChange}>
      <label className={style.uploadLabel}>
        <span className={style.uploadButton}>Choose File</span>
        <span>
          {fileName && !clearStatus ? (
            fileName
          ) : (
            <>
              No file chosen&nbsp;
              <i
                aria-hidden="true"
                className={classNames(style.uploadHelp, 'fa fa-question')}
                onClick={event => event.preventDefault()}
                title={UPLOAD_SEARCH_TOOLTIP}
              />
            </>
          )}
        </span>
        <input
          accept=".xlsx"
          className="file-upload-input"
          id="input"
          onChange={handleChange}
          onClick={resetFile}
          type="file"
        />
      </label>
      {fileChosen && !fileName && (
        <div className={style.uploadError}>
          Error: the format of this file is incorrect. Download a template to see a properly formatted Excel file.
        </div>
      )}
      <div className={style.templateDownload}>
        <a href={uploadTemplatePath} download>
          Download Template
        </a>
      </div>
    </BrowseCheckbox>
  );
};

BrowseUploadSearchComponent.propTypes = {
  clearStatus: PropTypes.bool,
  filter: PropTypes.instanceOf(Map).isRequired,
  info: PropTypes.instanceOf(Map).isRequired,
  onChange: PropTypes.func.isRequired,
};

/** Browse upload search component. */
export const BrowseUploadSearch = memo(BrowseUploadSearchComponent);
